var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IQOS',{class:{
      'iqos-transparent': !_vm.isActive
  },attrs:{"title":_vm.$t('integrations.poster_instant_ui.title'),"readonly":false}},[_c('p',{staticClass:"comment c-gray pt-0"},[_vm._v("\n      "+_vm._s(_vm.$t('integrations.poster_instant_ui.desc'))+"\n  ")]),_c('IQOSTogle',{model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }